export default __webpack_public_path__ + "static/media/showcase-reports.01b2aade.jpg";